import { Nowrap } from '@farmersdog/corgi-x';
import { getDeliveryEstimateText } from '../../utils';
import {
  DeliveredIconSvg,
  IngredientsIconSvg,
  SaucepanIconSvg,
} from './assets';

interface ValueProp {
  id: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconLabel: string;
  text: JSX.Element | string;
}

export const olsValueProps: ValueProp[] = [
  {
    id: 'human-grade-safety',
    icon: IngredientsIconSvg,
    iconLabel: 'Dog food ingredients',
    text: (
      <>
        <Nowrap>Human-grade</Nowrap> <Nowrap>safety standards</Nowrap>
      </>
    ),
  },
  {
    id: 'real-food-gently-cooked',
    icon: SaucepanIconSvg,
    iconLabel: 'Ingredients in Saucepan',
    text: (
      <>
        <Nowrap>Real food,</Nowrap> <Nowrap>gently cooked</Nowrap>
      </>
    ),
  },
  {
    id: 'delivery-estimate',
    icon: DeliveredIconSvg,
    iconLabel: 'Dog food delivery box',
    text: getDeliveryEstimateText('desktop') as JSX.Element,
  },
];

export const olsVetsValueProps: ValueProp[] = [
  {
    id: 'human-grade-safety',
    icon: IngredientsIconSvg,
    iconLabel: 'Dog food ingredients',
    text: (
      <>
        <Nowrap>Human-grade</Nowrap> <Nowrap>safety standards</Nowrap>
      </>
    ),
  },
  {
    id: 'real-food-gently-cooked',
    icon: SaucepanIconSvg,
    iconLabel: 'Ingredients in Saucepan',
    text: (
      <>
        <Nowrap>Real food,</Nowrap> <Nowrap>gently cooked</Nowrap>
      </>
    ),
  },
  {
    id: 'free-delivery',
    icon: DeliveredIconSvg,
    iconLabel: 'Dog food delivery box',
    text: 'Free delivery to your door',
  },
];
